export default "__VITE_ASSET__BqGBU5LY__"